import React from 'react';
import { motion } from 'framer-motion';

const photos = [
  { src: '/image/cabinet-room.webp', alt: 'Salle de soins moderne — cabinet Pluridental 62' },
  { src: '/image/cabinet-waiting.webp', alt: "Espace d'accueil — cabinet Pluridental 62" },
  { src: '/image/hero-cabinet.webp', alt: 'Salle de soins équipée avec lumière naturelle' },
  { src: '/image/techno-3dscan.webp', alt: 'Scanner intra-oral 3D et empreintes numériques' },
  { src: '/image/cabinet1.jpeg', alt: 'Détail de la salle de soins' },
];

const fadeUp = {
  initial: { opacity: 0, y: 32 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: '-100px' },
  transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
};

export default function GalerieV2() {
  return (
    <section id="galerie" className="bg-muted/40 py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div {...fadeUp} className="grid grid-cols-1 md:grid-cols-12 gap-y-6 mb-16 lg:mb-20">
          <div className="md:col-span-3">
            <span className="text-[11px] font-semibold uppercase tracking-[0.3em] text-foreground/55">
              06 — Le cabinet
            </span>
          </div>
          <div className="md:col-span-9">
            <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.9] tracking-tight text-foreground">
              Un lieu calme, <span className="italic">lumineux</span>.
            </h2>
          </div>
        </motion.div>

        <div className="grid grid-cols-12 gap-3 lg:gap-5">
          <motion.figure {...fadeUp} className="col-span-12 md:col-span-8 row-span-2 relative aspect-[4/3] md:aspect-auto md:min-h-[480px] overflow-hidden rounded-md ring-1 ring-foreground/10 group">
            <img
              src={photos[0].src}
              alt={photos[0].alt}
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03] motion-reduce:transition-none motion-reduce:group-hover:scale-100"
            />
          </motion.figure>

          <motion.figure {...fadeUp} className="col-span-6 md:col-span-4 relative aspect-[4/3] md:aspect-square overflow-hidden rounded-md ring-1 ring-foreground/10 group">
            <img
              src={photos[1].src}
              alt={photos[1].alt}
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03] motion-reduce:transition-none motion-reduce:group-hover:scale-100"
            />
          </motion.figure>

          <motion.figure {...fadeUp} className="col-span-6 md:col-span-4 relative aspect-[4/3] md:aspect-square overflow-hidden rounded-md ring-1 ring-foreground/10 group">
            <img
              src={photos[2].src}
              alt={photos[2].alt}
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03] motion-reduce:transition-none motion-reduce:group-hover:scale-100"
            />
          </motion.figure>

          <motion.figure {...fadeUp} className="col-span-6 md:col-span-6 relative aspect-[4/3] overflow-hidden rounded-md ring-1 ring-foreground/10 group">
            <img
              src={photos[3].src}
              alt={photos[3].alt}
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03] motion-reduce:transition-none motion-reduce:group-hover:scale-100"
            />
          </motion.figure>

          <motion.figure {...fadeUp} className="col-span-6 md:col-span-6 relative aspect-[4/3] overflow-hidden rounded-md ring-1 ring-foreground/10 group">
            <img
              src={photos[4].src}
              alt={photos[4].alt}
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03] motion-reduce:transition-none motion-reduce:group-hover:scale-100"
            />
          </motion.figure>
        </div>
      </div>
    </section>
  );
}
